import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { CustomGridCellProps } from "../CustomGridCellProps";
import { GridRowClickProps } from "../../GridRowClickProps";
import { ReadOnlyProps } from "../../../../Project/EditProject/ReadOnlyProps";

type Props = {
  localizedData: { text: string; value: any }[];
};

export function DropDownCell({
  localizedData,
  dataItem,
  field,
  onChange,
  editable,
  onRowClick,
  isReadOnly,
}: Props & CustomGridCellProps & GridRowClickProps & ReadOnlyProps) {
  const handleChange = (e: DropDownListChangeEvent) => {
    if (onChange) {
      onChange({
        dataIndex: 0,
        dataItem,
        field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };

  const myField = field || "";
  const dataValue = dataItem[myField] === null ? "" : dataItem[myField];

  return (
    <td onClick={() => onRowClick(dataItem)}>
      {editable && dataItem.inEdit && !isReadOnly ? (
        <DropDownList
          onChange={handleChange}
          value={localizedData.find((c) => c.value === dataValue)}
          data={localizedData}
          textField="text"
        />
      ) : (
        localizedData.find((val) => val.value === dataValue)?.text
      )}
    </td>
  );
}
